import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { DistributionModel } from '../../../models/distribution.model';
import { DistributionService } from '../../../../../Common/TargetingShared/services/distribution.service';
import { DistributionStatus } from '../../../../../Common/TargetingShared/enum/distribution-status.enum';
import { DistributionSendFrom } from '../../../models/distribution-send-from.model';

@Component({
    selector: 'agpr-distribution-header',
    templateUrl: './distribution.header.component.html',
    styleUrls: ['./distribution.header.component.scss'],
    standalone: false
})
export class DistributionHeaderComponent implements OnDestroy, OnInit {

    @Input() ariaDescribedBy: string;

    @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

    distribution: DistributionModel;
    editable: boolean = false;
    timezone: string;
    dateFormat: string;
    subjectLine: string;
    previewText: string;
    sendFrom: DistributionSendFrom;

    private subscriptions: Subscription[] = [];

    readonly buttonTypes = ButtonTypesEnum;
    readonly distributionStatus = DistributionStatus;

    constructor(
        public distributionService: DistributionService,
        protected currentUserStateService: CurrentUserStateService
    ) {
        this.subscriptions.push(
            this.distributionService.getFocusedResource().pipe(filter(x => !!x)).subscribe(distrib => {
                this.distribution = distrib;
                this.sendFrom = distrib.sendFrom;
                if (this.distribution.status !== DistributionStatus.draft) {
                    this.subjectLine = this.distributionService.renderFallbackTagsToDefault(
                        this.distributionService.processMergeTags(this.distribution.subjectLine, [])
                    );
                    this.previewText = this.distributionService.renderFallbackTagsToDefault(
                        this.distributionService.processMergeTags(this.distribution.previewText, [])
                    );
                }
            }),
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs => {
                this.timezone = prefs?.timeZone;
                this.dateFormat = prefs?.getDateFormatString(true, true, false);
            })
        );
    }

    ngOnInit() {
        this.editable = this.clicked.observed;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
    }

    emitClick() {
        if (this.editable) {
            this.distributionService.deselectBlock(true);
            this.clicked.emit();
        }
    }
}
